import React, { useRef } from 'react';
import { useMutation } from '@apollo/client';
import TrackerAnalyzeIngredientMutation from './TrackerAnalyzeIngredientMutation';

interface ITrackerAnalyzeIngredientConnectorApolloProps {
  children: ({
    analyzeIngredient,
    cancelAnalyzeIngredient,
  }: {
    analyzeIngredient: (input: any) => Promise<any>;
    cancelAnalyzeIngredient: () => void;
  }) => React.ReactElement;
}

const TrackerAnalyzeIngredientConnectorApollo: React.FC<
  ITrackerAnalyzeIngredientConnectorApolloProps
> = ({ children }) => {
  const [analyzeIngredientMutation] = useMutation(TrackerAnalyzeIngredientMutation);
  const abortControllerRef = useRef<AbortController | null>(null);

  const analyzeIngredient = async (input: any) => {
    // Create new AbortController for this request
    abortControllerRef.current = new AbortController();

    const response = await analyzeIngredientMutation({
      variables: { input },
      context: {
        fetchOptions: {
          signal: abortControllerRef.current.signal,
        },
      },
    });

    return response.data.dailyTracker.analyzeIngredient;
  };

  const cancelAnalyzeIngredient = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return children({ analyzeIngredient, cancelAnalyzeIngredient });
};

export default TrackerAnalyzeIngredientConnectorApollo;
